export const API_PERSON_DUPLICATE = 'App/TellUsMore::API_PERSON_DUPLICATE';
export const SELECT_INDEX_DUPLICATE = 'App/TellUsMore::SELECT_INDEX_DUPLICATE';
export const TELLUSMORE_LOADER = 'App/TellUsMore::TELLUSMORE_LOADER';
